export const broadcast = new EventTarget();
window.broadcast = broadcast;
export const broadcastChannels = {
	SplitScreenChange: 0,

	PopupWrapperClick: 1,

	SocketStateChange: 2,

	NetworkTimeChange: 3,

	WSReconnect: 4,
};
